import { render } from "./private-channel-button.vue?vue&type=template&id=22f4d634&lang=pug"
import script from "./private-channel-button.vue?vue&type=script&lang=js"
export * from "./private-channel-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__